<template>
  <div
    v-if="showSpinner"
    class="text-center p-5"
  >
    <div
      class="spinner-border text-success"
      role="status"
      :style="{
        height,
        width,
      }"
    >
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
/**
 * A single spinner to indicate a section is loading
 */
export default {
  props: {
    showSpinner: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      height: '3rem',
      width: '3rem',
    };
  },
}
</script>
